<template>
  <el-dialog class="dialogcz dialog_eventnone" :class="{'dialogcz_light':lightcolor}" :visible.sync="rainfallPop" :append-to-body="true" :show-close="false" :close-on-click-modal="false" :modal="false" width="40%" v-dialogDrag="true">
    <div slot="title">
      <div class="pop_title flexDiv">
        <div class="selectDiv">
          <el-select v-model="tempSTID" placeholder="请选择" @change="stidChange">
            <el-option  v-for="item in stids" :key="item.stid" :label="item.stnm" :value="item.stid">
            </el-option>
          </el-select>
        </div>
        <!-- <b>{{rainfallPopName}} </b> -->
        <span class="info" v-show="(accRain || accRain===0) || waterNow || waterStorage">
          <i class="el-icon-info"></i>
          <span v-show="accRain || accRain===0"> 累计雨量： {{accRain}}mm&nbsp;&nbsp;</span>
          <span v-show="waterNow"> 当前水位： {{waterNow}}m&nbsp;&nbsp;</span>
          <span v-show="waterStorage"> 当前库容： {{waterStorage}}万m³&nbsp;&nbsp;</span>
        </span>
      </div>
      <div class="closeBtn" @click="rainfallPop=false">关闭</div>
    </div>
    <div>
      <div class="rainfall_pop" ref="rainfallPop">
        <div class="tab-header flexDiv">
          <el-radio-group v-model="activeName" @change="rainWaterTabsChange" size="small">
            <el-radio-button label="0">水位雨量图</el-radio-button>
            <el-radio-button label="10">水位雨量表</el-radio-button>
            <el-radio-button label="1" v-if="sttp.includes('RR') && showtab.includes('1')">水库水位</el-radio-button>
            <el-radio-button label="2" v-if="sttp.includes('ZZ') && showtab.includes('2')">河道水位</el-radio-button>
          </el-radio-group>
          <div class="stcdCode">
            <span>终端编码:</span>
            <span>{{stcdCode}}</span>
            </div>
          <el-button size="mini" class="exportlist" @click="exportlist" v-show="activeName==10">导出</el-button>
        </div>
        <div class="tab-content" v-show="activeName==0">
          <div class="water_rain_top flexDiv">
            <div class="fastbtn">
              <el-radio-group v-model="fastbtn" size="mini">
                <el-radio-button v-for="(item,index) in radioList" :key="index" :label="item.label"  @click.native="timeChange(item.label)">{{item.name}}</el-radio-button>
              </el-radio-group>
            </div>
            <div v-show="timeChoose">
              <div class="block">
                <el-date-picker
                  v-model="waterRainBeginTime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  type="datetime"
                  size="mini"
                  @change="getRainfallData()"
                  :picker-options="Global.pickerOptionsStart(waterRainEndTime)"
                  placeholder="选择日期时间">
                </el-date-picker>
              </div>
              <span class="icon">-</span>
              <div class="block">
                <el-date-picker
                  v-model="waterRainEndTime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  type="datetime"
                  size="mini"
                  @change="getRainfallData()"
                  :picker-options="Global.pickerOptionsEnd(waterRainBeginTime)"
                  placeholder="选择日期时间">
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="water_rain_down" ref="calcHeight" v-loading="loading_chart"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.3)"
          >
            <div id="waterRain"></div>
          </div>
          <span class="unit waterUnit" v-if="sttp=='PP'">雨量(mm)</span>
          <span class="unit waterUnit" v-if="sttp!='PP'">水位(m)</span>
          <span class="unit rainUnit" v-if="sttp!='PP'">雨量(mm)</span>
        </div>
        <div class="tab-content" v-show="activeName==10">
          <div class="water_rain_top flexDiv flexSB">
            <div class="flexDiv">
              <div class="fastbtn">
                <el-radio-group v-model="fastbtn" size="mini">
                  <el-radio-button v-for="(item,index) in radioList" :key="index" :label="item.label"  @click.native="timeChange_table(item.label)">{{item.name}}</el-radio-button>
                </el-radio-group>
              </div>
              <div v-show="timeChoose">
                <div class="block">
                  <el-date-picker
                    v-model="waterRainBeginTime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    type="datetime"
                    size="mini"
                    @change="getTableData()"
                    :picker-options="Global.pickerOptionsStart(waterRainEndTime)"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </div>
                <span class="icon">-</span>
                <div class="block">
                  <el-date-picker
                    v-model="waterRainEndTime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    type="datetime"
                    size="mini"
                    @change="getTableData()"
                    :picker-options="Global.pickerOptionsEnd(waterRainBeginTime)"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div>
              <el-radio-group v-model="timeSpan" @change="getTableData()">
                <el-radio :label="1">分钟</el-radio>
                <el-radio :label="2">小时</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="water_rain_down">
            <div class="tableDiv" ref="tableDiv" v-loading="loading_table"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.3)"
            >
              <el-table :data="tableData" border :height="tableheight">
                <el-table-column prop="time" label="时间" align="center">
                </el-table-column>
                <el-table-column prop="rain" label="雨量(mm)" align="center">
                </el-table-column>
                <el-table-column prop="water" label="水位(m)" v-if="sttp.includes('RR') || sttp.includes('ZZ')"  align="center">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="tab-content" v-show="activeName==1">
          <div class="water_rain_top flexDiv">
          </div>
          <div class="water_rain_down">
            <div class="reservoirDiv">
              <div class="duanmianChart">
                <div id="reservoirLine1" ref="reservoirLine1"></div>
                <div class="duanmianDiv" >
                  <img src="@/assets/homepage_img/duanmian.png">
                </div>
                <div id="piechart1"></div>
                <div class="wave">
                  <wave :y="-waveY"></wave>
                </div>
                <div class="chartname">{{stnm}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-content"  v-show="activeName==2">
          <div class="water_rain_down">
            <div class="riverDiv">
              <div id="dmtlineChart1" ref="dmtlineChart"></div>
              <div class="imgDiv" ref="imgDiv"><img src="@/assets/homepage_img/hd.png"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import '@/utils/drag.js' // el-dialog拖拽功能
import wave from './wave'
import monitorTypes from '@/store/types/monitor'
import comprehensiveMapTypes from '@/store/types/comprehensiveMap'
import api from '@/api/homepage'
export default {
  props: {},
  computed: {},
  components: { wave },
  data () {
    return {
      stcdCode: '',
      stids: [],
      rainfallPop: false,
      rainfallPopName: '',
      waterRainEndTime: '',
      waterRainBeginTime: '',
      tipChart: null,
      timeChoose: false,
      activeName: '0',
      sttp: '',
      stnm: '',
      waterStorage: '', // 当前水库库容
      rainNow: null,
      waterNow: null,
      accRain: null,
      radioList: [
        { name: '前24h', label: '1' },
        { name: '前48h', label: '2' },
        { name: '前72h', label: '3' },
        { name: '自定义', label: '自定义' }
      ],
      tempSTID: 0,
      tableData: [],
      loading_table: false,
      loading_chart: false,
      tableheight: 100,
      timeSpan: 2,
      fastbtn: '3',
      guaranteeWater: null,
      warningWater: null,
      dmtHeight: 35,
      reservoirH: 0,
      reservoirW: 0,
      waveY: 30,
      impoundmentRate: null,
      ssw: null,
      showtab: '0,1,2', // 需要展示tab页
      lightcolor: false, // 浅色系
      color: '#fff'// 弹窗颜色风格
    }
  },
  methods: {
    getAllStationsBystid(stid) {
      api.getAllStationsBystid({
        stid: stid
      }).then(res => {
        this.stids = res.data.data
      })
    },
    exportlist () {
      api.exportRainWaterList({
        sid: 22,
        stid: this.tempSTID,
        beginTime: this.waterRainBeginTime,
        endTime: this.waterRainEndTime,
        span: this.timeSpan === 1 ? 5 : 60
      }).then(res => {
        window.location.href = this.Global.basePath + res.data.data
      })
    },
    async showlog (item, color, showtab) {
      Object.assign(this.$data, this.$options.data())
      this.stcdCode = item.stcd // 显示终端编码
      this.waterRainEndTime = this.getCurrentTime(0)
      this.waterRainBeginTime = this.getCurrentTime(3)
      if (color) {
        this.color = color
        this.lightcolor = true
      }
      if (showtab) {
        this.showtab = showtab
      }
      this.tempSTID = Number(item.stid ? item.stid : item.id)
      this.getAllStationsBystid(this.tempSTID)
      this.impoundmentRate = item.impoundmentRate ? item.impoundmentRate : null
      this.ssw = item.ssw ? item.ssw : null
      this.waterStorage = ''
      this.rainfallPopName = item.stnm
      this.sttp = item.sttp
      this.getSyntheticalWaterAndRain()
      // this.getdetail(item)
      this.activeName = '0'
      if (!item.impoundmentRate && item.sttp.includes('RR')) {
        let result = await this.$store.dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, { STID: this.tempSTID })
        if (result.rows.length > 0) {
          this.impoundmentRate = result.rows[0].impoundmentRate
          this.ssw = result.rows[0].ssw
        }
      }
      this.rainfallPop = true
      this.$nextTick(() => {
        this.getRainfallData()
      })
    },
    async stidChange() {
      let result = await this.$store.dispatch(monitorTypes.GET_SYNTHETICAL_WATERANDRAIN, { STID: this.tempSTID, type: 'all' })
      let item = result.rows[0]
      this.sttp = item.sttp
      this.stcdCode = item.stcd // 显示终端编码
      this.impoundmentRate = item.impoundmentRate ? item.impoundmentRate : null
      this.ssw = item.ssw ? item.ssw : null
      this.activeName = '0'
      if (!item.impoundmentRate && item.sttp.includes('RR')) {
        let result = await this.$store.dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, { STID: this.tempSTID })
        if (result.rows.length > 0) {
          this.impoundmentRate = result.rows[0].impoundmentRate
          this.ssw = result.rows[0].ssw
        }
      }
      this.$nextTick(() => {
        this.getRainfallData()
      })
    },
    closeLog () {
      this.rainfallPop = false
    },
    timeChange (label) {
      if (label === '自定义') {
        this.timeChoose = true
      } else {
        this.timeChoose = false
        this.waterRainBeginTime = this.getCurrentTime(label)
        this.waterRainEndTime = this.getCurrentTime(0)
        this.getRainfallData()
      }
    },
    timeChange_table (label) {
      if (label === '自定义') {
        this.timeChoose = true
      } else {
        this.timeChoose = false
        this.waterRainBeginTime = this.getCurrentTime(label)
        this.waterRainEndTime = this.getCurrentTime(0)
        this.getTableData()
      }
    },
    rainWaterTabsChange (val) {
      if (this.tipChart) {
        this.tipChart.clear()
      }
      if (this.activeName === '0') {
        this.getRainfallData()
      } else if (this.activeName === '1') {
        this.get5MYuRunData()
        this.drawPieChart(this.impoundmentRate)
      } else if (this.activeName === '2') {
        this.$nextTick(() => {
          let dmtlineChart = this.$refs.dmtlineChart
          let imgDiv = this.$refs.imgDiv
          this.dmtHeight = dmtlineChart.offsetHeight - imgDiv.offsetHeight - 1
          this.drawLineChart_hd()
        })
      } else if (this.activeName === '10') {
        this.$nextTick(() => {
          this.getTableData()
        })
      }
    },
    // 获取当前雨量,水位,保证水位等
    getSyntheticalWaterAndRain () {
      this.$store.dispatch(monitorTypes.GET_SYNTHETICAL_WATERANDRAIN, {
        STID: this.tempSTID,
        type: 'all'
      }).then(data => {
        this.rainNow = data.rows[0].rainNow_Str
        this.waterNow = data.rows[0].water_Str
        this.guaranteeWater = data.rows[0].guaranteeWater
        this.warningWater = data.rows[0].warningWater
      })
    },
    get5MYuRunData () {
      this.$store.dispatch(comprehensiveMapTypes.GET_YURUN_DATA, {
        sTID: this.tempSTID,
        beginTime: this.waterRainBeginTime,
        endTime: this.waterRainEndTime
      }).then(data => {
        this.$nextTick(() => {
          if (this.activeName === '1') {
            this.$nextTick(() => {
              let reservoir = this.$refs.reservoirLine1
              this.reservoirH = reservoir.offsetHeight
              this.reservoirW = reservoir.offsetWidth
              this.drawLineChart_sk(data)
            })
          } else {
            this.$nextTick(() => {
              let dmtlineChart = this.$refs.dmtlineChart
              let imgDiv = this.$refs.imgDiv
              this.dmtHeight = dmtlineChart.offsetHeight - imgDiv.offsetHeight - 1
              this.drawLineChart_hd()
            })
          }
        })
      })
    },
    getTableData () {
      this.tableData = []
      // 判断时间区间间隔天数
      if (this.activeName === '10') {
        let dayDiff = this.Global.differenceTime(this.waterRainBeginTime, this.waterRainEndTime)
        if (dayDiff > 7) {
          this.$notify.warning({ title: '警告', message: '所选时间区间不能超过7天!', duration: '7000' })
          return false
        }
      }
      this.loading_table = true
      this.$store.dispatch(comprehensiveMapTypes.GET_RAINWATER_MINUTES_TOTAL, {
        sTID: this.tempSTID,
        stationType: '',
        beginTime: this.waterRainBeginTime,
        endTime: this.waterRainEndTime,
        span: this.timeSpan === 1 ? 5 : 60
      }).then(data => {
        this.loading_table = false
        for (let i = 0; i < data.tMs.length; i++) {
          this.$nextTick(() => {
            this.tableheight = this.$refs.tableDiv.offsetHeight - 5
            this.tableData.push({
              time: data.tMs[i],
              rain: data.rainValues[i],
              water: data.waterValues ? data.waterValues[i] : null
            })
          })
        }
      })
    },
    // 实时雨情对应stid站点水位雨量/雨量水位数据
    getRainfallData () {
      let _this = this
      this.loading_chart = true
      let bdate = new Date(_this.waterRainBeginTime).getTime()
      let edate = new Date(_this.waterRainEndTime).getTime()
      let timeSpan = (edate - bdate) / 1000 / 60 / 60
      // 时间间隔小于24小时 则取5分钟数据
      this.$store.dispatch(comprehensiveMapTypes.GET_RAINWATER_MINUTES_TOTAL, {
        sTID: _this.tempSTID,
        stationType: '',
        beginTime: _this.waterRainBeginTime,
        endTime: _this.waterRainEndTime,
        span: timeSpan <= 24 ? 5 : 60
      }).then(data => {
        this.loading_chart = false
        this.accRain = data.accRain
        this.rainChart(data)
        if (data.lastestZStorage) {
          this.waterStorage = data.lastestZStorage
        }
      })
    },
    rainChart (data) {
      let yAxis = []
      let legendData = []
      let rainData = data.rainValues ? JSON.parse(JSON.stringify(data.rainValues)) : []
      let rainmax = rainData.sort(function (a, b) {
        return b - a
      })
      rainmax = rainmax[0] ? Math.round(rainmax[0] + 2) : 2
      let watermax = data.maxWater ? data.maxWater + 0.2 : 0
      let watermin = data.minWater ? data.minWater - 0.2 : 0
      let max = 0
      let min = 0
      if (data.grZs && data.wrZs) {
        max = Math.max(data.maxWater, data.grZs[0] ? data.grZs[0] : data.maxWater, data.wrZs[0] ? data.wrZs[0] : data.maxWater)
        min = Math.min(data.minWater, data.grZs[0] ? data.grZs[0] : data.minWater, data.wrZs[0] ? data.wrZs[0] : data.minWater)
      } else if (data.grZs) {
        max = Math.max(data.maxWater, data.grZs[0] ? data.grZs[0] : data.maxWater)
        min = Math.min(data.minWater, data.grZs[0] ? data.grZs[0] : data.minWater)
      } else if (data.wrZs) {
        max = Math.max(data.maxWater, data.wrZs[0] ? data.wrZs[0] : data.maxWater)
        min = Math.min(data.minWater, data.wrZs[0] ? data.wrZs[0] : data.minWater)
      }
      let gap = (max - min) / 2
      if (max && min) {
        watermax = max + gap / 2
        watermin = min - gap / 2
      }
      if (!data.maxWater) {
        watermax = null
        watermin = null
      }
      if (this.sttp === 'PP') {
        yAxis = [
          {
            type: 'value',
            interval: 30,
            inverse: true,
            min: 0,
            max: rainmax,
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              lineStyle: {
                color: this.color
              }
            }
          }
        ]
        legendData = ['雨量']
      } else {
        yAxis = [
          {
            type: 'value',
            min: watermin,
            max: watermax,
            scale: true,
            splitNumber: 5,
            // interval: 100,
            axisLabel: {
              formatter: function (value, index) {
                return value.toFixed(1)
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                opacity: 0.1
              }
            },
            axisLine: {
              lineStyle: {
                color: this.color
              }
            }
          },
          {
            type: 'value',
            interval: 30,
            inverse: true,
            min: 0,
            max: rainmax,
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              lineStyle: {
                color: this.color
              }
            }
          }
        ]
        if (this.sttp.includes('ZZ')) {
          legendData = ['雨量', { name: '水位', icon: 'line' }, { name: '警戒水位', icon: 'line' }, { name: '保证水位', icon: 'line' }]
        } else if (this.sttp.includes('RR')) {
          legendData = ['雨量', { name: '水位', icon: 'line' }, { name: '汛限水位', icon: 'line' }]
        }
      }
      let myChart = this.$echarts.init(document.getElementById('waterRain'))
      myChart.clear()
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params, ticket, callback) {
            let htmlStr = ''
            for (var i = 0; i < params.length; i++) {
              let param = params[i]
              let xName = param.name// x轴的名称
              let seriesName = param.seriesName// 图例名称
              let value = param.value// y轴值
              let color = param.color// 图例颜色
              let danwei = 'mm'
              if (seriesName === '雨量') {
                danwei = 'mm'
              } else {
                danwei = 'm'
              }
              if (i === 0) {
                htmlStr += xName + '<br/>'// x轴的名称
              }
              htmlStr += `<div>
                <span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:${color};"></span>
                ${seriesName}：${value === undefined ? '-' : value}${danwei}
              </div>`
            }
            return htmlStr
          }
        },
        legend: {
          data: legendData,
          textStyle: {
            color: this.color
          }
        },
        grid: {
          left: '1%',
          right: '2%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.tMs,
          axisLine: {
            show: false,
            lineStyle: {
              color: this.color
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: this.color
            },
            formatter: function (params) {
              let arr = params.split(' ')
              let newParamsName = arr[1] + '\n' + arr[0]
              return newParamsName
            }
          }
        },
        yAxis: yAxis,
        series: [
          {
            name: '雨量',
            type: 'bar',
            yAxisIndex: this.sttp === 'PP' ? 0 : 1,
            itemStyle: {
              color: '#33C9DE'
            },
            data: data.rainValues
          },
          {
            name: '水位',
            type: 'line',
            symbol: 'none',
            itemStyle: {
              color: '#48D1CC'
            },
            data: data.waterValues
          },
          {
            name: this.sttp.includes('ZZ') ? '警戒水位' : '汛限水位',
            type: 'line',
            symbolSize: 0,
            itemStyle: {
              color: this.sttp.includes('ZZ') ? '#FFD700' : 'red' // 警戒水位金色
            },
            data: data.wrZs
          },
          {
            name: '保证水位',
            type: 'line',
            symbolSize: 0,
            itemStyle: {
              color: 'red'
            },
            data: data.grZs
          }
        ]
      })
      this.tipChart = myChart
    },
    drawLineChart_sk (data) {
      let xData = []
      let waterData = [] //
      let wrzData = [] // 警戒水位
      let sswData = [] // 死水位
      let waterMaxData = []// 用以比较
      data.runData_Reservoir.forEach((el, i) => {
        let dateArr = el.date.split(' ')
        let date = dateArr[0].split('-')
        xData.push(date[1] + '-' + date[2] + ' ' + dateArr[1])
        if (el.alert !== 0) {
          wrzData.push(el.alert)
        }
        // waterData.push(el.value)
        waterData.push(this.waterNow)
        sswData.push(this.ssw)
        if (el.value) {
          waterMaxData.push(el.value)
        }
      })
      let ymin = 0
      let ymax = 0

      let labelAlert = [12, -12]
      let labelNow = [12, -12]
      let labelSsw = [12, 5]
      // if (wrzData[0]) {
      //   if (this.impoundmentRate) {
      //     let y = wrzData[0] * this.impoundmentRate / 100
      //     ymin = ((wrzData[0] - this.waterNow) * y / (wrzData[0] - y) - this.waterNow) * -1 // (wrzData[0] - y)/(y-0) = (wrzData[0] - this.waterNow)/(this.waterNow-ymin)求ymin
      //   }
      //   ymax = (wrzData[0] - ymin) / 7 * 3 + wrzData[0]
      //   if (this.waterNow > wrzData[0]) {
      //     labelAlert = [12, 5]
      //     labelNow = [12, -12]
      //   }
      // } else {
      //   ymax = Math.max(...waterMaxData)
      //   ymax = ymax * 10 / 7
      // }
      if (wrzData[0]) {
        if (this.ssw) {
          let gap = (wrzData[0] - this.ssw) / 4
          ymin = this.ssw - 2 * gap
          if (this.waterNow - wrzData[0] > gap) {
            for (let i = 0; i < waterData.length; i++) {
              waterData[i] = wrzData[0] + gap
            }
          }
          if (this.waterNow > wrzData[0]) {
            labelAlert = [12, 5]
            labelNow = [12, -12]
          } else if (wrzData[0] > this.waterNow && this.waterNow > sswData[0]) {
            if (wrzData[0] - this.waterNow < gap) {
              labelNow = [12, 5]
            } else if (this.waterNow - sswData[0] < gap) {
              labelNow = [12, -12]
            }
          } else if (sswData[0] > this.waterNow) {
            if (sswData[0] - this.waterNow < gap) {
              labelSsw = [12, -12]
              labelNow = [12, 5]
            } else if (sswData[0] - this.waterNow > gap) {
              labelSsw = [12, -12]
              labelNow = [12, -12]
              for (let i = 0; i < waterData.length; i++) {
                waterData[i] = sswData[0] - gap
              }
            }
          }
        }
        ymax = (wrzData[0] - ymin) / 7 * 3 + wrzData[0]
      } else {
        ymax = Math.max(...waterMaxData)
        ymax = ymax * 10 / 7
      }
      let svgH = (waterData[0] - ymin) / (ymax - ymin) * this.reservoirH // svg理论像素高度
      let svgPx = this.reservoirW / 100 //  100为svg画布宽度,svg 1单位大小和像素的比例
      this.waveY = svgH / svgPx - 10 // 10 为svg高度为0的位置
      let myChart = this.$echarts.init(document.getElementById('reservoirLine1'))
      myChart.clear()
      myChart.setOption({
        grid: {
          left: '0%',
          right: '0%',
          bottom: '0%',
          top: this.duanmianHeight,
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          show: false,
          data: xData,
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        }],
        yAxis: [
          {
            type: 'value',
            min: ymin,
            max: ymax,
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '水位',
            type: 'line',
            smooth: true,
            symbol: 'none',
            data: waterData,
            itemStyle: {
              color: this.color
            },
            lineStyle: {
              normal: {
                color: this.color,
                width: 1
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M958.417329 735.20866501l-446.417329-446.41733001-446.417329 446.41733001z',
              symbolSize: [12, 0],
              label: {
                position: labelNow,
                formatter: `当前水位: ${this.waterNow}m`,
                textStyle: {
                  fontSize: '15'
                }
              }
            }
          },
          {
            name: '汛限水位',
            type: 'line',
            itemStyle: {
              color: '#FFA500'
            },
            symbolSize: 0,
            lineStyle: {
              normal: {
                type: 'dotted',
                color: '#FFA500',
                width: 2
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M958.417329 735.20866501l-446.417329-446.41733001-446.417329 446.41733001z',
              symbolSize: [12, 0],
              label: {
                position: labelAlert,
                formatter: `汛限水位: ${wrzData[0]}m`,
                textStyle: {
                  fontSize: '15'
                }
              }
            },
            data: wrzData
          },
          {
            name: '死水位',
            type: 'line',
            itemStyle: {
              color: 'yellow'
            },
            symbolSize: 0,
            lineStyle: {
              normal: {
                type: 'dotted',
                color: 'yellow',
                width: 2
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M958.417329 735.20866501l-446.417329-446.41733001-446.417329 446.41733001z',
              symbolSize: [12, 0],
              label: {
                position: labelSsw,
                formatter: `死水位: ${sswData[0]}m`,
                textStyle: {
                  fontSize: '15'
                }
              }
            },
            data: sswData
          }
        ]
      })
      this.tipChart = myChart
    },
    drawLineChart_hd () {
      let waterData = [] //
      let wrzData = []
      let grzData = []
      let xData = []
      for (let i = 0; i < 10; i++) {
        waterData.push(this.waterNow)
        grzData.push(this.guaranteeWater)
        wrzData.push(this.warningWater)
        xData.push(i)
      }
      let gap = 1
      if (this.guaranteeWater) {
        gap = this.guaranteeWater - this.waterNow
      }
      let ymin = Math.min(...waterData) - gap
      let ymax = Math.max(...waterData) + gap / 2
      if (this.guaranteeWater && ymin > this.guaranteeWater) {
        ymin = this.guaranteeWater - gap
      }
      if (this.warningWater && ymin > this.warningWater) {
        ymin = this.warningWater - gap
      }
      if (this.guaranteeWater) {
        ymax = this.guaranteeWater
      }
      let myChart = this.$echarts.init(document.getElementById('dmtlineChart1'))
      myChart.clear()
      myChart.setOption({
        grid: {
          left: '0%',
          right: '0%',
          bottom: '10%',
          top: this.dmtHeight,
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: xData,
          show: false,
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        }],
        yAxis: [{
          show: false,
          min: ymin, // ymin
          max: ymax, // ymax
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        }],
        series: [
          {
            name: '水位',
            type: 'line',
            smooth: true,
            symbol: 'none',
            data: waterData,
            itemStyle: {
              color: '#1B9ED6'
            },
            lineStyle: {
              normal: {
                color: '#1B9ED6',
                width: 1
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M65.582671 288.791335l446.417329 446.41733 446.417329-446.41733z',
              symbolSize: [12, 0],
              symbolOffset: [200, 2],
              label: {
                position: [15, 0],
                color: '#fff',
                fontSize: '15',
                formatter: `当前水位: ${this.waterNow}m`
              }
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear', // 设置线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgb(31,111,239,1)'
                    },
                    {
                      offset: 1,
                      color: 'rgb(31,111,239,0)'
                    }
                  ],
                  globalCoord: false // 缺省为 false
                },
                origin: 'start'
              }
            }
          },
          {
            name: '警戒水位',
            type: 'line',
            itemStyle: {
              color: '#FFD700'
            },
            symbolSize: 0,
            lineStyle: {
              normal: {
                type: 'dotted',
                color: '#FFD700',
                width: 2
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M958.417329 735.20866501l-446.417329-446.41733001-446.417329 446.41733001z',
              symbolSize: [12, 8],
              symbolOffset: [400, 10],
              label: {
                position: [15, 0],
                color: this.color,
                fontSize: '15',
                formatter: `警戒水位: ${wrzData[0]}m`
              }
            },
            data: wrzData
          },
          {
            name: '保证水位',
            type: 'line',
            itemStyle: {
              color: '#E02020'
            },
            symbolSize: 0,
            lineStyle: {
              normal: {
                type: 'dotted',
                color: '#E02020',
                width: 2
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M65.582671 288.791335l446.417329 446.41733 446.417329-446.41733z',
              symbolSize: [12, 8],
              symbolOffset: [200, -12],
              label: {
                position: [15, 0],
                color: this.color,
                fontSize: '15',
                formatter: `保证水位: ${grzData[0]}m`
              }
            },
            data: grzData
          }
        ]
      })
      this.tipChart = myChart
    },
    drawPieChart (impoundmentRate) {
      let myChart = this.$echarts.init(document.getElementById('piechart1'))
      myChart.clear()
      if (!(impoundmentRate || impoundmentRate === 0)) {
        return
      }
      let textcolor = '#fff'
      if (impoundmentRate > 100) {
        textcolor = 'yellow'
      }
      myChart.setOption({
        title: {
          text: `${Math.round(impoundmentRate)}%`,
          left: 'center',
          top: 'center',
          subtext: '蓄水率',
          textStyle: {
            color: textcolor
          },
          subtextStyle: {
            color: textcolor
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            let str = ''
            str = `蓄水率：${impoundmentRate}%`
            return str
          }
        },
        color: ['#3985ff', '#87d0fc'],
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '80%',
            data: [
              { value: impoundmentRate, name: '蓄水率' },
              { value: impoundmentRate < 100 ? 100 - impoundmentRate : 0, name: '' }
            ],
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    },
    getCurrentTime (num) {
      let nowdate = new Date()
      nowdate.setTime(nowdate.getTime() - 24 * 60 * 60 * 1000 * Number(num))
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      // let mm = nowdate.getMinutes()
      let time =
        year +
        '-' +
        (mon > 9 ? mon : '0' + mon) +
        '-' +
        (dd > 9 ? dd : '0' + dd) +
        ' ' +
        (hh > 9 ? hh : '0' + hh) +
        ':00'
        // (mm > 9 ? mm : '0' + mm)
      return time
    }
  }
}
</script>
<style lang="less"  scoped >
.dialogcz /deep/ .el-dialog{
  *{
    box-sizing: border-box;
  }
  background: #193654;
  margin-top: 20vh!important;
  .el-dialog__header{
    pointer-events: all;
    padding: 0;
    position: relative;
    .pop_title {
      width: 100%;
      height: 45px;
      line-height: 45px;
      color: #fff;
      padding: 0px 20px;
      font-size: 18px;
      border-bottom: 1px solid #2e4b69;
      .selectDiv{
        width: 200px;
        .el-select{
          .el-input__inner{
            background: transparent;
            color: #fff;
            font-size: 18px;
            font-weight: bolder;
            padding: 0;
            border: none;
          }
          .el-input__icon{
            color: #fff;
          }
        }
      }
      .info{
        font-size: 14px;
        color: #ccc;
      }
    }
    .closeBtn{
      position: absolute;
      height: 45px;
      line-height: 45px;
      top: 0;
      right: 20px;
      color: #6f8497;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .el-dialog__body{
    pointer-events: all;
    overflow: hidden;
    padding: 0;
  }
  .rainfall_pop {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    position: relative;
    .tab-header{
      background-color: #193654;
      padding: 5px 5px;
      border-bottom: #2e4b69 1px solid;
      color: #fff;
      display: flex;
      justify-content: space-between;
      .el-radio-button__inner{
        color: #fff;
        background: #152a3f;
        border: none;
        border-radius: 0;
      }
      .el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #32659e;
        border: none;
      }
      .el-button{
        border: none;
        color: #fff;
        background: #152a3f;
        border-radius: 0;
      }
      .exportlist{
        border: solid 1px #fff;
        background: #152a3f;
        border-radius: 5;
        color: #fff;
        float: right;
      }
      .stcdCode {
        margin-right: 5px;
        span:nth-child(2) {
          font-weight: bold;
          font-weight: 18px;
        }
      }
    }
    .tab-content{
      background-color: #152942;
      position: relative;
      .info_content{
        width: 90%;
        padding-bottom: 40px;
        margin: 0 auto;
        height: 308px;
        margin-bottom: 7px;
        flex-wrap: wrap;
        position: relative;
        .info_text{
          box-sizing: border-box;
          width: 50%;
          line-height: 30px;
          border-bottom: 1px solid #2e4b69;
          font-size: 16px;
          color: #fff;
          padding-left: 20px;
          padding-right: 30px;
        }
      }
      .water_rain_top {
        width: 100%;
        height: 33px;
        padding: 5px 5px 0;
        margin-bottom: 7px;
        .fastbtn {
          // width: 200px;
          padding-right: 5px;
          height: 100%;
          .el-radio-button--mini .el-radio-button__inner {
            background: rgba(0, 0, 0, 0);
            color: #fff;
            padding: 0 12px;
            height: 28px;
            line-height: 28px;
          }
            .el-radio-button__orig-radio:checked
            + .el-radio-button__inner {
            color: #409eff;
          }
        }
        .block {
          width: 150px;
          height: 100%;
          float: left;
          .el-date-editor.el-input,
          .el-date-editor.el-input__inner {
            width: 100% !important;
          }
        }
        .el-input--suffix .el-input__inner {
          padding-right: 0 !important;
          background: rgba(0, 0, 0, 0);
          color: #fff;
          border-color: #c78ae6;
        }
        .icon {
          width: 15px;
          height: 28px;
          color: #fff;
          font-size: 18px;
          line-height: 28px;
          text-align: center;
          display: block;
          float: left;
        }
        .el-select {
          width: 100px;
          height: 35px;
          margin: 0 5px;
        }
      }
      .water_rain_down {
        width: 100%;
        height: 280px;
        .tableDiv{
          width: 100%;
          height: 100%;
          padding: 0 5px 5px;
        }
        #waterRain {
          width: 100%;
          height: 100%;
        }
        .el-table {
          background: rgba(0, 0, 0, 0);
          th,
          tr,
          td {
            color: #fff;
            background: rgba(0, 0, 0, 0);
            border-right: 1px solid #c78ae6;
            border-bottom: 1px solid #c78ae6;
          }
          .el-table__body tr:hover td {
            background: rgba(23, 44, 93, 0.8);
          }
        }
        .el-table--border {
          border: 1px solid #c78ae6;
        }
        .el-table--border::after,
        .el-table::before {
          background: none;
        }
      }
      .storageDiv{
        width: 100%;
        height: 320px;
        #storageLine{
          width: 100%;
          height: 100%;
        }
      }
    }
    .unit {
      display: block;
      width: 100px;
      height: 20px;
      color: #fff;
      position: absolute;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      line-height: 20px;
    }
    .waterUnit {
      top: 45px;
      left: -8px;
    }
    .rainUnit {
      top: 45px;
      right: -5px;
    }
    .waterStorage {
      color: #fff;
      position: absolute;
      font-size: 14px;
      top: 60px;
      right: 20px;
    }
    .reservoirDiv{
      width: 100%;
      height: 100%;
      .duanmianChart{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
      }
      .duanmianDiv{
        width: 96px;
        height: 100%;
        position: absolute;
        bottom: 0;
        right: 330px;
        margin: auto;
        z-index: 100;
        img{
          // width: 100%;
          height: 100%;
        }
      }
      .chartname{
        position: absolute;
        font-size: 14px;
        left: 10px;
        bottom: 10px;
        z-index: 10;
      }
      .overrun{
        height: 24px;
        line-height: 24px;
        padding: 0 5px;
        position: absolute;
        font-size: 14px;
        left: 80px;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #e02020;
        z-index: 10;
      }
      #reservoirLine1{
        width: calc(100% - 330px);
        height: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 10;
      }
      #piechart1{
        position: absolute;
        top: 0;
        right: 0;
        width: 160px;
        height: 160px;
      }
      .wave{
        width: calc(100% - 330px);
        height: 100%;
        overflow: hidden;
        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 0;
      }
      .wavelow{
        width: 330px;
        height: 100%;
        z-index: 1;
        overflow: hidden;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .riverDiv{
      width: 100%;
      height: 100%;
      #gcxlineChart1{
        width: 100%;
        height: 100%;
      }
      #dmtlineChart1{
        width: 100%;
        height: 100%;
      }
      .imgDiv{
        width: 100%;
        height: 215px;
        position: absolute;
        left: 0;
        bottom: 0;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .chartname{
        height: 20px;
        font-size: 14px;
        position: absolute;
        left: 10px;
        top: 10px;
      }
    }
  }
}
.dialogcz_light /deep/ .el-dialog{//浅色系
  background: #409EFF;
  .el-dialog__header{
    .pop_title {
      color: #FFF;
      border-bottom: 1px solid #ccc;
      .info{
        color: #FFF;
      }
    }
    .closeBtn {
      color: #fff;
    }
  }
  .rainfall_pop {
    .tab-header{
      background-color: #EFF1F5;
      border-bottom: #ccc 1px solid;
      color: #fff;
      .el-radio-button__inner{
        color: #de2b9f;
        background: #fff3f3;
      }
      .el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #409EFF;
        color: #fff;
      }
      .el-button{
        color: #fff;
        background: #152a3f;
      }
      .stcdCode {
        margin-right: 5px;
        color: #666;
        span:nth-child(2) {
          font-weight: bold;
          font-weight: 18px;
        }
      }
    }
    .tab-content{
      background-color: #EFF1F5;
      .water_rain_top {
        .fastbtn {
          .el-radio-button--mini .el-radio-button__inner {
            background: fff;
            color: #2F4F4F;
          }
            .el-radio-button__orig-radio:checked
            + .el-radio-button__inner {
            color: #409eff;
          }
        }
        .el-input--suffix .el-input__inner {
          padding-right: 0 !important;
          background: fff;
          color: #2F4F4F;
          border-color: #c78ae6;
        }
        .icon {
          color: #2F4F4F;
        }
      }
      .water_rain_down{
        .el-table {
          th,
          tr,
          td {
            color: rgb(39, 36, 36);
            background: rgba(0, 0, 0, 0);
            border-right: 1px solid #36263d;
            border-bottom: 1px solid #36263d;
          }
          .el-table__body tr:hover td {
            background: rgba(189, 199, 221, 0.8);
          }
        }
        .el-table--border {
          border: 1px solid #36263d;
        }
      }
    }
    .unit {
      color: #2F4F4F;
    }
    .waterStorage {
      color: #2F4F4F;
    }
  }
}
.dialog_eventnone{
  pointer-events: none;
}
.flexDiv {
  /* 横向排列 */
  display: flex;
  align-items: center;
}
.flexDivCol {
  /* 垂直居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flexSB {
  /* 两端对齐 */
  justify-content: space-between;
}
.flexSA {
  /* 每个项目两侧的间隔相等 */
  justify-content: space-around;
}

/deep/ ::-webkit-scrollbar{
  width: 8px;
  height: 10px;
  background-color: rgba(0,0,0,0);
}
/deep/::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: rgba(0, 0, 0, 0);
}
/deep/::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #69aadf;
}
</style>
